import Vue from 'vue'
import Message from './Message.vue'
import Confirm from './ConfirmCmp.vue'

const MessageConstructor = Vue.extend(Message)
// const ConfirmConstructor = Vue.extend(Confirm)


function $_message(props = {}) {
  const messageDom = new MessageConstructor({
    el: document.createElement('div'),
    props: Object.keys(props).reduce((prev, key) => {
      prev[key] = {
        default: props[key]
      }
      return prev
    }, {}),
  })
  document.body.appendChild(messageDom.$el)
  messageDom.show()
}

function $_confirm(props) {
  const ConfirmConstructor = Vue.extend({
    render(h) {
      return h(Confirm, {
        props
      })
    }
  })
  const confirmDom = new ConfirmConstructor({
    el: document.createElement('div'),
  })
  document.body.appendChild(confirmDom.$el)
  confirmDom.$children[0].show()
}

function registry() {
  Vue.prototype.$_message = $_message
  Vue.prototype.$_confirm = $_confirm
}

export default registry



// WEBPACK FOOTER //
// ./src/components/apiComponents.js